
export default {
	name: 'ContactPage',
	data ()
	{
		return {
			socialMedia: [
				{ name: '$InstagramLogo', route: 'https://www.instagram.com/enifex_official' },
				{ name: '$TwitterLogo', route: 'https://twitter.com/EnifexCom' },
				{ name: '$LinkedInLogo', route: 'https://www.linkedin.com/company/enifex/' },
				{ name: '$TelegramLogo', route: 'https://t.me/enifexx' },
				{ name: '$FacebookLogo', route: 'https://www.facebook.com/Enifex.official' },
				{ name: '$YoutubeLogo', route: 'https://www.youtube.com/@enifex_official' },
				{ name: '$DiscordLogo', route: 'https://discord.gg/DGNA4aYD' },
				{ name: '$TiktokLogo', route: 'https://www.tiktok.com/@enifex.com' }
			],
		};
	},
	head ()
	{
		// Phone: +971 50 845 1481
		 if (this.$route.path === '/') return {};

		const baseUrl = 'https://enifex.com';

		const breadcrumbData = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
			"itemListElement": [
			{
				"@type": "ListItem",
				"position": 1,
				"name": "Home",
				"item": baseUrl
			},
			{
				"@type": "ListItem",
				"position": 2,
				"name": "Contact Us",
				"item": `${baseUrl}/contact-us`
			}
			]
		};
		return {
			title: 'Enifex - Contact Us',
			link: [
				{
					rel: 'canonical',
					href: `https://www.enifex.com${this.$route.path}`
				}
			],
			script: [
				{
					hid: 'schema-contact-breadcrumb',
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbData)
				}
			]
		};
	},
}
